<template>
    <div class="sort-dropdown">
        <span>{{ $t('installationoverview.sort_by') }}:</span>
        <a
            v-for="sort in sortsOptions"
            :key="sort.id"
            :class="{ bold: isSort(sort.column, sort.value, sort.order) }"
            @click="sortOn(sort.column, sort.value, sort.order)"
        >
            {{ $t(sort.label, { i18nFallback: sort.i18nFallback }) }}
        </a>
    </div>
</template>
<script>
import { Vue, Prop, Component } from 'vue-property-decorator';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import '../atoms/v-tooltip';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

@Component
@AngularLocaleBundle('installationoverview')
export default class VrmInstallationsTableDropdown extends Vue {
    @Prop({ type: Function, required: true })
    sortOn;
    @Prop({ type: Array, required: true })
    sortsOptions;
    @Prop({ type: Function, required: true })
    isSort;
}
</script>
